import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CatalogRepositoryService } from '../../services/catalog-repository.service';
import { ModalService } from '@shared/services/modal/modal.service';
import { combineLatest, first } from 'rxjs';
import { CategorySelectionModalComponent } from '../category-selection-modal/category-selection-modal.component';
import { ModalSize } from '@shared/enums/modal-sizes';
import { HelixRoutes } from '@shared/enums/routes';
import { GetCatalogCategoriesResponse as Category } from '@medindex-webapi';
import { RouterLink } from '@angular/router';
import { AsyncPipe, NgForOf } from '@angular/common';
import { YmReachGoalDirective } from '@shared/directives/ym-reach-goal.directive';
import { YmGoalCatalog } from '../../enums/ym-goal-catalog.enum';

@Component({
  selector: 'app-categories-button',
  templateUrl: './categories-button.component.html',
  styleUrls: ['./categories-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, AsyncPipe, NgForOf, YmReachGoalDirective],
})
export class CategoriesButtonComponent {
  constructor(
    public repository: CatalogRepositoryService,
    private modal: ModalService
  ) {}

  readonly routeCatalog = `/${HelixRoutes.Catalog}/`;
  protected readonly YmGoalCatalog = YmGoalCatalog;

  showCategoryModal(): void {
    combineLatest([
      this.repository.selectedCategory$,
      this.repository.categories$,
    ])
      .pipe(first())
      .subscribe(
        ([selectedCategory, categories]: [
          Category | null,
          Category[] | null
        ]): void => {
          this.modal.create({
            nzTitle: 'Категории анализов',
            nzContent: CategorySelectionModalComponent,
            nzStyle: {
              width: ModalSize.BigInfo,
            },
            nzComponentParams: {
              selectedCategory,
              categories,
            },
            nzFooter: null,
          });
        }
      );
  }
}
